import React from 'react';
import { U21Chip } from 'app/shared/u21-ui/components';
import { IconDevices } from '@u21/tabler-icons';
import pluralize from 'pluralize';

import {
  FullTxnResponse,
  ShortTxnResponse,
} from 'app/modules/transactions/types';
import {
  CachedActionEventResponse,
  ShortActionEventResponse,
} from 'app/modules/actionEvents/responses';
import { useFingerprintCount } from 'app/modules/deviceIntelligence/hooks/fingerprint';

type DeviceIntelligenceChipProps = {
  event: 'txn' | 'action';
  row:
    | FullTxnResponse
    | CachedActionEventResponse
    | ShortActionEventResponse
    | ShortTxnResponse;

  onClick?: (e: React.MouseEvent) => void;
} & React.HTMLAttributes<HTMLElement>;

export const DeviceIntelligenceChip = React.forwardRef<
  HTMLDivElement,
  DeviceIntelligenceChipProps
>(({ event, row, onClick, ...rest }, ref) => {
  const trueCount = useFingerprintCount(event, row);

  return (
    <U21Chip
      ref={ref}
      {...rest}
      icon={<IconDevices />}
      color={trueCount > 0 ? 'error' : 'default'}
      onClick={onClick}
    >
      {trueCount > 0 ? pluralize('Signal', trueCount, true) : 'Signals'}
    </U21Chip>
  );
});
